import React, { ReactElement } from 'react';
import styled from 'styled-components';

import { getAppText } from 'Utils/text';
import {
  BRAND_LOGO_URL,
  PARTNER_FOOTER_IN_COOPERATION_WITH,
} from '../../themes.constants';

export const InCorporationWithDanskeBank = (): ReactElement => (
  <Container>
    <Text>{getAppText(PARTNER_FOOTER_IN_COOPERATION_WITH)} </Text>
    <Logo alt="Danske bank logo" src={BRAND_LOGO_URL.danskeBank} />
  </Container>
);

const Container = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
`;

const Text = styled.span`
  white-space: nowrap;
  line-height: 27px;
`;

const Logo = styled.img`
  margin-left: 8px;
  height: 16px;
`;
